import React, { useEffect, useState } from 'react'
import Modal from '../Modal'
import "./styles.css"
import axios from 'axios';
import { MAIN_URL } from '../../constants';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../RefreshToken/RefreshToken';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'

// COURSE:
//   Step 1 → POST /courses/create                (photo, price, mentor_id)
//   Step 2 → POST /courses/add-translations/:id  (language, title, description) — ixtiyoriy
//
// CHAPTER:
//   Step 1 → POST /courses/chapters/add                          (course_id) — title yo'q
//   Step 2 → POST /courses/chapters/add-translation/:chapter_id  (exam_data pdf, title, language) — ixtiyoriy

const LANGUAGES = [
    { value: 'uz', label: 'UZ' },
    { value: 'en', label: 'EN' },
    { value: 'ru', label: 'RU' },
];

const FormModal = ({
    isModalOpen,
    setModalOpen,
    isCourseModal,
    newCourse,
    courseChangeId,
    handleNewChapter,
    setChangedChapter,
}) => {
    const navigate = useNavigate();
    const TOKEN = localStorage.getItem('admin_token');
    const ROLE = localStorage.getItem('role');

    // ─── Shared ───────────────────────────────────────────────────────────────
    const [loading, setLoading] = useState(false);
    const [step, setStep] = useState(1);

    // ─── Mentors ──────────────────────────────────────────────────────────────
    const [mentors, setMentors] = useState({});
    const [mentorsList, setMentorsList] = useState([]);
    const [courseMentor, setCourseMentor] = useState('');

    // ─── Course Step 1 ────────────────────────────────────────────────────────
    const [createdCourseId, setCreatedCourseId] = useState(null);
    const [courseBase, setCourseBase] = useState({ photo: null, price: '' });
    const [addFileName, setAddFileName] = useState('');
    const [photoInspect, setPhotoInspect] = useState(false);
    const [errorPhoto, setErrorPhoto] = useState(false);

    // ─── Course Step 2 (translations) ─────────────────────────────────────────
    const [savedTranslations, setSavedTranslations] = useState([]);
    const [currentTranslation, setCurrentTranslation] = useState({ title: '', description: '', language: '' });
    const [translationLoading, setTranslationLoading] = useState(false);

    // ─── Chapter Step 1 ───────────────────────────────────────────────────────
    // title yo'q — faqat course_id API ga ketadi, title translation da beriladi
    const [createdChapterId, setCreatedChapterId] = useState(null);

    // ─── Chapter Step 2 (translations) ────────────────────────────────────────
    const [savedChapterTranslations, setSavedChapterTranslations] = useState([]);
    const [currentChapterTrans, setCurrentChapterTrans] = useState({ title: '', language: '', pdf: null });
    const [addFilePdf, setAddFilePdf] = useState('');
    const [pdfInspect, setPdfInspect] = useState(false);
    const [chapterTranslationLoading, setChapterTranslationLoading] = useState(false);

    // ─── Fetch staff / mentors ────────────────────────────────────────────────
    useEffect(() => {
        api.get('/management/staff/profile', { headers: { Authorization: `Bearer ${TOKEN}` } })
            .then((res) => setMentors(res?.data))
            .catch((err) => console.error('staff/profile error:', err));
    }, []);

    useEffect(() => {
        api.get('/management/mentors', { headers: { Authorization: `Bearer ${TOKEN}` } })
            .then((res) => setMentorsList(res?.data))
            .catch((err) => console.error('mentors error:', err));
    }, []);

    // ─── Reset on close ───────────────────────────────────────────────────────
    useEffect(() => {
        if (!isModalOpen) {
            setStep(1);
            setCreatedCourseId(null);
            setCourseBase({ photo: null, price: '' });
            setAddFileName('');
            setErrorPhoto(false);
            setPhotoInspect(false);
            setCourseMentor('');
            setSavedTranslations([]);
            setCurrentTranslation({ title: '', description: '', language: '' });
            setCreatedChapterId(null);
            setSavedChapterTranslations([]);
            setCurrentChapterTrans({ title: '', language: '', pdf: null });
            setAddFilePdf('');
            setPdfInspect(false);
        }
    }, [isModalOpen]);

    // ─── File handlers ────────────────────────────────────────────────────────
    const handleCoursePhotoChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const allowed = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
        if (!allowed.includes(file.type)) {
            setPhotoInspect(true);
            e.target.value = '';
            return;
        }
        setPhotoInspect(false);
        setErrorPhoto(false);
        setCourseBase((prev) => ({ ...prev, photo: file }));
        setAddFileName(file.name);
    };

    const handleChapterPdfChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        if (file.type !== 'application/pdf') {
            setPdfInspect(true);
            e.target.value = '';
            return;
        }
        setPdfInspect(false);
        setCurrentChapterTrans((prev) => ({ ...prev, pdf: file }));
        setAddFilePdf(file.name);
    };

    // =========================================================================
    // COURSE – Step 1: POST /courses/create
    // =========================================================================
    const handleCreateCourse = () => {
        if (!courseBase.photo) { setErrorPhoto(true); return; }
        if (!courseBase.price) { toast.warn('Narxni kiriting'); return; }
        if (ROLE !== 'mentor' && !courseMentor) { toast.warn('Mentor tanlang'); return; }

        setLoading(true);
        const fd = new FormData();
        fd.append('photo', courseBase.photo);
        fd.append('price', courseBase.price);
        fd.append('mentor_id', ROLE === 'mentor' ? mentors?.id : courseMentor);

        axios.post(`${MAIN_URL}/courses/create`, fd, {
            headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${TOKEN}` },
        })
            .then((res) => {
                setCreatedCourseId(res.data?.id);
                newCourse(res.data);
                setLoading(false);
                setStep(2);
            })
            .catch((err) => {
                console.error('Create course error:', err);
                toast.warn(err.message);
                setLoading(false);
            });
    };

    // =========================================================================
    // COURSE – Step 2: POST /courses/add-translations/:id
    // =========================================================================
    const handleSaveCourseTranslation = async () => {
        if (!currentTranslation.language) { toast.warn('Tilni tanlang'); return; }
        if (!currentTranslation.title.trim()) { toast.warn('Sarlavhani kiriting'); return; }
        if (savedTranslations.find((t) => t.language === currentTranslation.language)) {
            toast.warn('Bu til allaqo\'shilgan');
            return;
        }

        setTranslationLoading(true);
        try {
            await axios.post(
                `${MAIN_URL}/courses/add-translations/${createdCourseId}`,
                [{ language: currentTranslation.language, title: currentTranslation.title, description: currentTranslation.description }],
                { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${TOKEN}` } }
            );
            toast.success(`${currentTranslation.language.toUpperCase()} tarjimasi saqlandi!`);
            setSavedTranslations((prev) => [...prev, { ...currentTranslation }]);
            setCurrentTranslation({ title: '', description: '', language: '' });
        } catch (err) {
            console.error('Course translation error:', err);
            toast.error('Tarjimani saqlashda xatolik');
        } finally {
            setTranslationLoading(false);
        }
    };

    const handleFinishCourse = () => {
        if (savedTranslations.length === 0 && (currentTranslation.title.trim() || currentTranslation.language)) {
            toast.warn('"Tarjimani saqlash" tugmasini bosing yoki formni bo\'shatib chiqing');
            return;
        }
        setModalOpen(false);
        navigate('/preview');
    };

    // =========================================================================
    // CHAPTER – Step 1: POST /courses/chapters/add  (faqat course_id)
    // title yo'q — translation da beriladi
    // =========================================================================
    const handleCreateChapter = () => {
        setLoading(true);
        const fd = new FormData();
        fd.append('course_id', courseChangeId);

        axios.post(`${MAIN_URL}/courses/chapters/add`, fd, {
            headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${TOKEN}` },
        })
            .then((res) => {
                setCreatedChapterId(res.data?.id);
                setLoading(false);
                setStep(2);
            })
            .catch((err) => {
                console.error('Create chapter error:', err);
                toast.error('Chapterni yaratishda xatolik');
                setLoading(false);
            });
    };

    // =========================================================================
    // CHAPTER – Step 2: POST /courses/chapters/add-translation/:chapter_id
    //   multipart/form-data: exam_data (pdf), title, language
    // =========================================================================
    const handleSaveChapterTranslation = async () => {
        if (!currentChapterTrans.language) { toast.warn('Tilni tanlang'); return; }
        if (!currentChapterTrans.title.trim()) { toast.warn('Sarlavhani kiriting'); return; }
        if (!currentChapterTrans.pdf) { toast.warn('PDF faylni yuklang'); return; }
        if (savedChapterTranslations.find((t) => t.language === currentChapterTrans.language)) {
            toast.warn('Bu til allaqo\'shilgan');
            return;
        }

        setChapterTranslationLoading(true);
        const fd = new FormData();
        fd.append('exam_data', currentChapterTrans.pdf);
        fd.append('title', currentChapterTrans.title);
        fd.append('language', currentChapterTrans.language);

        try {
            await axios.post(
                `${MAIN_URL}/courses/chapters/add-translation/${createdChapterId}`,
                fd,
                { headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${TOKEN}` } }
            );
            toast.success(`${currentChapterTrans.language.toUpperCase()} tarjimasi saqlandi!`);
            setSavedChapterTranslations((prev) => [...prev, { ...currentChapterTrans }]);
            setCurrentChapterTrans({ title: '', language: '', pdf: null });
            setAddFilePdf('');
        } catch (err) {
            console.error('Chapter translation error:', err);
            toast.error('Tarjimani saqlashda xatolik');
        } finally {
            setChapterTranslationLoading(false);
        }
    };

    const handleFinishChapter = () => {
        if (savedChapterTranslations.length === 0 && (currentChapterTrans.title.trim() || currentChapterTrans.language)) {
            toast.warn('"Tarjimani saqlash" tugmasini bosing yoki formni bo\'shatib chiqing');
            return;
        }

        // Chapters ro'yxatini yangilash
        axios.get(`${MAIN_URL}/courses/chapters?course_id=${courseChangeId}`, {
            headers: { Authorization: `Bearer ${TOKEN}` },
        })
            .then((res) => {
                const chapters = res.data?.map((ch) => ({ value: ch.id, label: ch.title }));
                handleNewChapter(chapters);
                if (chapters.length > 0) setChangedChapter(chapters[chapters.length - 1].value);
            })
            .catch(() => { });

        setModalOpen(false);
        navigate('/preview');
    };

    // ─── Confirm dispatcher ───────────────────────────────────────────────────
    const handleConfirm = () => {
        if (isCourseModal) {
            step === 1 ? handleCreateCourse() : handleFinishCourse();
        } else {
            step === 1 ? handleCreateChapter() : handleFinishChapter();
        }
    };

    // ─── Available languages ──────────────────────────────────────────────────
    const availableCourseLanguages = LANGUAGES.filter(
        (l) => !savedTranslations.find((t) => t.language === l.value)
    );
    const availableChapterLanguages = LANGUAGES.filter(
        (l) => !savedChapterTranslations.find((t) => t.language === l.value)
    );

    // ─── Modal meta ───────────────────────────────────────────────────────────
    const getTitle = () => {
        if (isCourseModal) return step === 1 ? 'Create course:' : 'Add translations:';
        return step === 1 ? 'Create chapter:' : 'Add chapter translations:';
    };

    const getConfirmLabel = () => (step === 1 ? 'Next →' : 'Finish & Preview');

    // =========================================================================
    // RENDER
    // =========================================================================
    return (
        <Modal
            title={getTitle()}
            isOpen={isModalOpen}
            onClose={() => setModalOpen(false)}
            onConfirm={handleConfirm}
            loading={loading}
            confirmLabel={getConfirmLabel()}
        >

            {/* ── COURSE STEP 1 ── */}
            {isCourseModal && step === 1 && (
                <form id="courseForm" className="course-form-modal">
                    <label className={`form-group chose-file-box ${errorPhoto ? 'error-border' : ''}`}>
                        <div className="choseFile"><i className="ri-add-box-line"></i></div>
                        <p>{addFileName || 'Attach course photo'}</p>
                        <input className="input-file-img" type="file" name="photo" accept="image/*" onChange={handleCoursePhotoChange} />
                    </label>
                    {photoInspect && <span className="error-file">Faqat rasm fayl yuklang!</span>}

                    <div className="form-group">
                        <input
                            required type="number" name="price" placeholder="Enter course price" min={0}
                            value={courseBase.price}
                            onChange={(e) => setCourseBase((prev) => ({ ...prev, price: e.target.value }))}
                        />
                    </div>

                    <div className="form-group">
                        {ROLE === 'mentor' && (
                            <select disabled>
                                <option>{mentors?.first_name} {mentors?.last_name}</option>
                            </select>
                        )}
                        {(ROLE === 'admin' || ROLE === 'super_admin') && (
                            <select required value={courseMentor} onChange={(e) => setCourseMentor(e.target.value)}>
                                <option value="" hidden>Assign mentor</option>
                                {mentorsList?.map((m) => (
                                    <option key={m?.id} value={m?.id}>{m?.first_name} {m?.last_name}</option>
                                ))}
                            </select>
                        )}
                    </div>
                </form>
            )}

            {/* ── COURSE STEP 2 ── */}
            {isCourseModal && step === 2 && (
                <div className="course-form-modal">
                    {savedTranslations.length > 0 && (
                        <div className="saved-translations">
                            {savedTranslations.map((t) => (
                                <span key={t.language} className="translation-badge">{t.language.toUpperCase()} ✓</span>
                            ))}
                        </div>
                    )}
                    <p className="translation-hint">
                        {savedTranslations.length === 0
                            ? 'Tarjima qo\'shish ixtiyoriy. Xohlasangiz qo\'shing yoki "Finish & Preview" ni bosing.'
                            : 'Yana til qo\'shishingiz yoki "Finish & Preview" ni bosishingiz mumkin.'}
                    </p>

                    {availableCourseLanguages.length > 0 && (
                        <div className="translation-form">
                            <div className="form-group">
                                <select value={currentTranslation.language} onChange={(e) => setCurrentTranslation((prev) => ({ ...prev, language: e.target.value }))}>
                                    <option value="" hidden>Til tanlang</option>
                                    {availableCourseLanguages.map((l) => <option key={l.value} value={l.value}>{l.label}</option>)}
                                </select>
                            </div>
                            <div className="form-group">
                                <input
                                    type="text" placeholder="Kurs nomi"
                                    value={currentTranslation.title}
                                    onChange={(e) => setCurrentTranslation((prev) => ({ ...prev, title: e.target.value }))}
                                />
                            </div>
                            <div className="form-group">
                                <ReactQuill
                                    value={currentTranslation.description}
                                    onChange={(val) => setCurrentTranslation((prev) => ({ ...prev, description: val }))}
                                    className="modal-textarea"
                                    placeholder="Kurs tavsifi..."
                                />
                            </div>
                            <button type="button" className="btn-save-translation" onClick={handleSaveCourseTranslation} disabled={translationLoading}>
                                {translationLoading ? 'Saqlanmoqda...' : '+ Tarjimani saqlash'}
                            </button>
                        </div>
                    )}
                    {availableCourseLanguages.length === 0 && (
                        <p className="translation-hint">Barcha tillar qo'shildi.</p>
                    )}
                </div>
            )}

            {/* ── CHAPTER STEP 1 ── */}
            {/* title yo'q — faqat course_id API ga ketadi, "Next" bosilganda chapter yaratiladi */}
            {!isCourseModal && step === 1 && (
                <div className="course-form-modal">
                    <p className="translation-hint">
                        "Next" tugmasini bosing — chapter yaratiladi va tarjima qo'shish sahifasiga o'tasiz.
                    </p>
                </div>
            )}

            {/* ── CHAPTER STEP 2 ── */}
            {!isCourseModal && step === 2 && (
                <div className="course-form-modal">
                    {savedChapterTranslations.length > 0 && (
                        <div className="saved-translations">
                            {savedChapterTranslations.map((t) => (
                                <span key={t.language} className="translation-badge">{t.language.toUpperCase()} ✓ — {t.title}</span>
                            ))}
                        </div>
                    )}
                    <p className="translation-hint">
                        {savedChapterTranslations.length === 0
                            ? 'Tarjima qo\'shish ixtiyoriy. Xohlasangiz qo\'shing yoki "Finish & Preview" ni bosing.'
                            : 'Yana til qo\'shishingiz yoki "Finish & Preview" ni bosishingiz mumkin.'}
                    </p>

                    {availableChapterLanguages.length > 0 && (
                        <div className="translation-form">
                            <div className="form-group">
                                <select value={currentChapterTrans.language} onChange={(e) => setCurrentChapterTrans((prev) => ({ ...prev, language: e.target.value }))}>
                                    <option value="" hidden>Til tanlang</option>
                                    {availableChapterLanguages.map((l) => <option key={l.value} value={l.value}>{l.label}</option>)}
                                </select>
                            </div>
                            <div className="form-group">
                                <input
                                    type="text" placeholder="Chapter nomi"
                                    value={currentChapterTrans.title}
                                    onChange={(e) => setCurrentChapterTrans((prev) => ({ ...prev, title: e.target.value }))}
                                />
                            </div>
                            <div className="form-group">
                                <label className="form-group chose-file-box">
                                    <div className="choseFile"><i className="ri-add-box-line"></i></div>
                                    <p>{addFilePdf || 'Exam PDF yuklang'}</p>
                                    <input className="input-file-img" type="file" accept="application/pdf" onChange={handleChapterPdfChange} />
                                </label>
                                {pdfInspect && <span className="error-file">Faqat PDF fayl yuklang!</span>}
                            </div>
                            <button type="button" className="btn-save-translation" onClick={handleSaveChapterTranslation} disabled={chapterTranslationLoading}>
                                {chapterTranslationLoading ? 'Saqlanmoqda...' : '+ Tarjimani saqlash'}
                            </button>
                        </div>
                    )}
                    {availableChapterLanguages.length === 0 && (
                        <p className="translation-hint">Barcha tillar qo'shildi.</p>
                    )}
                </div>
            )}

        </Modal>
    );
};

export default FormModal;